// extracted by mini-css-extract-plugin
module.exports = {"carFeatures":"CarFeatures_carFeatures__NkDzY","carFeatures__icon-img":"CarFeatures_carFeatures__icon-img__rbdJ5"};